"use client";

import { c as _c } from "react/compiler-runtime";
import { Star } from "lucide-react";
import type { PotmVote } from "./types";
const dateFormatter = new Intl.DateTimeFormat(undefined, {
  month: "short",
  day: "numeric"
});
interface PotmCardProps {
  vote: PotmVote;
  labels: Record<string, string>;
}
export default function PotmCard(t0) {
  const $ = _c(36);
  const {
    vote,
    labels
  } = t0;
  const match = vote.matchModel;
  const player = vote.playerModel;
  const homeName = match?.homeTeam?.shortName || match?.homeTeam?.name || "\u2014";
  const awayName = match?.awayTeam?.shortName || match?.awayTeam?.name || "\u2014";
  const ft = match?.scores?.ftScore;
  const score = ft && ft.homeGoals != null && ft.awayGoals != null ? `${ft.homeGoals} : ${ft.awayGoals}` : "vs";
  let t1;
  if ($[0] !== player?.firstName || $[1] !== player?.lastName || $[2] !== player?.name || $[3] !== vote.playerId) {
    t1 = player?.name || `${player?.firstName || ""} ${player?.lastName || ""}`.trim() || vote.playerId;
    $[0] = player?.firstName;
    $[1] = player?.lastName;
    $[2] = player?.name;
    $[3] = vote.playerId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const playerName = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Star className="h-2.5 w-2.5" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = labels.gameTypePotm || "POTM";
  let t4;
  if ($[6] !== t3) {
    t4 = <span className="inline-flex items-center gap-1 rounded-full bg-amber-500/10 px-1.5 py-0.5 text-[10px] font-semibold text-amber-600">{t2}{t3}</span>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== vote.createdAt) {
    t5 = dateFormatter.format(new Date(vote.createdAt));
    $[8] = vote.createdAt;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="text-[10px] text-muted-foreground">{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <div className="flex items-center justify-between">{t4}{t6}</div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== homeName) {
    t8 = <span className="font-medium text-foreground truncate flex-1 text-right">{homeName}</span>;
    $[15] = homeName;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== score) {
    t9 = <span className="shrink-0 rounded bg-muted px-2 py-0.5 text-xs font-bold text-foreground tabular-nums">{score}</span>;
    $[17] = score;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== awayName) {
    t10 = <span className="font-medium text-foreground truncate flex-1">{awayName}</span>;
    $[19] = awayName;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8 || $[23] !== t9) {
    t11 = <div className="flex items-center justify-between gap-2 text-sm">{t8}{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t8;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const t12 = labels.votedFor || "Voted for";
  let t13;
  if ($[25] !== t12) {
    t13 = <span className="text-muted-foreground">{t12}</span>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== playerName) {
    t14 = <span className="shrink-0 rounded-full bg-primary/10 px-2 py-0.5 font-semibold text-primary">{playerName}</span>;
    $[27] = playerName;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13 || $[30] !== t14) {
    t15 = <div className="flex items-center justify-between gap-2 text-xs border-t border-border/30 mt-1 pt-2">{t13}{t14}</div>;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t11 || $[33] !== t15 || $[34] !== t7) {
    t16 = <div className="flex flex-col gap-2 rounded-lg bg-card p-3">{t7}{t11}{t15}</div>;
    $[32] = t11;
    $[33] = t15;
    $[34] = t7;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
}